<div class="card">
  <div class="col-auto">
    <div class="img">
      <img src="assets/images/customer-support/craig.jpg" alt="Craig Lund" i18n-alt="@@support.contactCard.name" onError="this.src='assets/images/icons/contact.svg'">
    </div>
  </div>
  <div class="p-1"></div>
  <div class="col">
    <h3 class="name" i18n="@@support.contactCard.name">CRAIG LUND</h3>
    <h5 class="position" i18n="@@support.contactCard.position">Head of Operations at BitOasis</h5>
    <div class="p-1"></div>
    <a href="mailto:craig@bitoasis.net" class="email">craig@bitoasis.net</a>
    <div class="phone" i18n="@@support.contactCard.phone">WhatsApp: +971 52 598 5655</div>
  </div>
</div>